import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import { useMemberships } from '@sayyesschool/frontend/features/memberships';
import { Chip, Tabs } from '@sayyesschool/frontend/ui-components';

import MembershipForm from '@/components/memberships/membership-form';
import MembershipsTable from '@/components/memberships/memberships-table';

export default function MembershipsPage() {
    const [memberships, actions] = useMemberships();

    const [tab, setTab] = useState('active');
    const [membership, setMembership] = useState();
    const [isDialogOpen, setDialogOpen] = useState(false);

    const handleSubmit = useCallback(data => {
        return actions.createMembership(data)
            .then(() => setDialogOpen(false));
    }, [actions]);

    const handleUpdate = useCallback(data => {
        return actions.updateMembership(membership.id, data)
            .then(() => setDialogOpen(false));
    }, [membership, actions]);

    const handleDelete = useCallback(membership => {
        return actions.deleteMembership(membership.id);
    }, [actions]);

    const handleCreate = useCallback(() => {
        setMembership();
        setDialogOpen(true);
    }, []);

    const handleEdit = useCallback(membership => {
        setMembership(membership);
        setDialogOpen(true);
    }, []);

    const handleDialogClose = useCallback(() => {
        setMembership();
        setDialogOpen(false);
    }, []);

    const filteredMemberships = memberships?.filter(filters[tab]);

    if (!filteredMemberships) return <LoadingIndicator />;

    return (
        <Page id="memberships">
            <Page.Header
                title="Абонементы"
                center={
                    <Chip
                        as={Link}
                        to="/memberships/packs"
                        content="Пакеты"
                    />
                }
                actions={[
                    {
                        key: 'add',
                        icon: 'add',
                        content: 'Создать абонемент',
                        variant: 'solid',
                        onClick: handleCreate
                    }
                ]}
            />

            <Page.Content>
                <Tabs
                    value={tab}
                    items={[
                        { key: 'active', value: 'active', content: 'Активные' },
                        { key: 'inactive', value: 'inactive', content: 'Неактивные' },
                        { key: 'all', value: 'all', content: 'Все' }
                    ]}
                    disableUnderline
                    onChange={(_, value) => setTab(value)}
                />

                <Page.Section
                    variant="outlined"
                    compact
                >
                    <MembershipsTable
                        memberships={filteredMemberships}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                </Page.Section>
            </Page.Content>

            <FormDialog
                title={membership?.id ? 'Изменить абонемент' : 'Новый абонемент'}
                form="membership-form"
                open={isDialogOpen}
                onClose={handleDialogClose}
            >
                <MembershipForm
                    id="membership-form"
                    membership={membership}
                    onSubmit={membership?.id ? handleUpdate : handleSubmit}
                />
            </FormDialog>
        </Page>
    );
}

const filters = {
    active: membership => membership.isActive,
    inactive: membership => !membership.isActive,
    all: () => true
};